import clsx from 'clsx';
import React from 'react';
import styles from './Icons.module.scss';
import { IconsProps } from './Icons.type';

export const ArrowDownIcon: React.FC<IconsProps> = ({ className }) => (
    <i className={clsx(styles.arrowDown, className)} />
);
